import { Component } from 'react';
import { AlertTriangle, ArrowLeft, RefreshCw } from 'lucide-react';

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'test') {
      console.error('Frontend section failed to render.', error, errorInfo);
    }
    this.props.onError?.(error, errorInfo);
  }

  handleReset = () => {
    this.setState({ error: null });
    this.props.onReset?.();
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const {
      sectionName = 'This part of the application',
      resetLabel = 'Try again',
      showReload = false,
    } = this.props;

    return (
      <section className="app-error-state panel" role="alert" aria-live="assertive">
        <span className="app-error-icon" aria-hidden="true"><AlertTriangle size={24} /></span>
        <p className="eyebrow">Something went wrong</p>
        <h2>{sectionName} could not be opened</h2>
        <p>Your work has not been submitted. You can safely retry or return to a stable workspace.</p>
        <div className="app-error-actions">
          <button type="button" className="primary-button" onClick={this.handleReset}>
            {this.props.onReset ? <ArrowLeft size={16} /> : <RefreshCw size={16} />}
            {resetLabel}
          </button>
          {showReload && (
            <button type="button" className="secondary-button" onClick={this.handleReload}>
              <RefreshCw size={16} /> Reload application
            </button>
          )}
        </div>
        {process.env.NODE_ENV === 'development' && (
          <details className="app-error-details">
            <summary>Technical details</summary>
            <code>{error.message}</code>
          </details>
        )}
      </section>
    );
  }
}

export default AppErrorBoundary;
